<template>
  <b-card no-body>
    <b-card-header>
      <b-card-title>Số lượng cán bộ trong từng Khoa/Bộ môn</b-card-title>
    </b-card-header>
    <b-card-body>
      <bar-chart-component
        ref="barChart1"
        id="bar-chart-1"
        :height="400"
        :data="employeesByDepartmentData.data"
        :options="employeesByDepartmentData.options"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BCardTitle,
} from 'bootstrap-vue'
import BarChartComponent from "@/views/admin/category/charts/component/BarChartComponent.vue";
import { mapActions, mapGetters } from "vuex";
import { $themeColors } from "@themeConfig";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BCardTitle,
    BarChartComponent
  },
  props: {
    filter: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      employeesByDepartmentData: {
        data: {
          labels: [],
          datasets: [
            {
              data: [],
              backgroundColor: chartColors.successColorShade,
              borderColor: 'transparent',
            },
          ],
        },
        options: {
          elements: {
            rectangle: {
              borderWidth: 2,
              borderSkipped: 'bottom',
            },
          },
          responsive: true,
          maintainAspectRatio: false,
          responsiveAnimationDuration: 500,
          legend: {
            display: false,
          },
          tooltips: {
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 8,
            shadowColor: chartColors.tooltipShadow,
            backgroundColor: $themeColors.light,
            titleFontColor: $themeColors.dark,
            bodyFontColor: $themeColors.dark,
          },
          scales: {
            xAxes: [
              {
                display: true,
                gridLines: {
                  display: true,
                  color: chartColors.grid_line_color,
                  zeroLineColor: chartColors.grid_line_color,
                },
                scaleLabel: {
                  display: false,
                },
                ticks: {
                  fontColor: chartColors.labelColor,
                },
              },
            ],
            yAxes: [
              {
                display: true,
                gridLines: {
                  color: chartColors.grid_line_color,
                  zeroLineColor: chartColors.grid_line_color,
                },
                ticks: {
                  stepSize: 10,
                  min: 0,
                  fontColor: chartColors.labelColor,
                },
              },
            ],
          },
        },
      },
    }
  },
  computed: {
    ...mapGetters( {
      employeesByDepartment: 'chart/employeesByDepartment',
    }),
  },
  watch: {
    'filter.trainingSystemId': async function () {
      await this.getDataFromStore()
    },
    'filter.yearId': async function () {
      await this.getDataFromStore()
    },
    'filter.semesterId': async function () {
      await this.getDataFromStore()
    }
  },
  async created() {
    await this.getDataFromStore()
  },
  methods:{
    ...mapActions({
      getEmployeesByDepartment: 'chart/getEmployeesByDepartment',
    }),
    async getDataFromStore(){
      this.isLoading = true
      try {
        await this.getEmployeesByDepartment(this.filter)
        if (this.employeesByDepartment.length > 0) {
          this.employeesByDepartmentData.data.labels = []
          this.employeesByDepartmentData.data.datasets[0].data = []
          this.employeesByDepartment.forEach((item, key) => {
            this.employeesByDepartmentData.data.labels.push(this.employeesByDepartment[key].departmentName)
            this.employeesByDepartmentData.data.datasets[0].data.push(this.employeesByDepartment[key].countEmployees)
          })
          this.$refs.barChart1.renderChart(this.employeesByDepartmentData.data, this.employeesByDepartmentData.options)
        }
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `[${e.code}] ${e.message}`,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.isLoading = false
      }
    }
  }
}

const chartColors = {
  primaryColorShade: '#836AF9',
  yellowColor: '#ffe800',
  successColorShade: '#28dac6',
  warningColorShade: '#ffe802',
  warningLightColor: '#FDAC34',
  infoColorShade: '#299AFF',
  greyColor: '#4F5D70',
  blueColor: '#2c9aff',
  blueLightColor: '#84D0FF',
  greyLightColor: '#EDF1F4',
  tooltipShadow: 'rgba(0, 0, 0, 0.25)',
  lineChartPrimary: '#666ee8',
  lineChartDanger: '#ff4961',
  labelColor: '#6e6b7b',
  grid_line_color: 'rgba(200, 200, 200, 0.2)',
}
</script>
